import { render, staticRenderFns } from "./RootLayout.vue?vue&type=template&id=22002b57&"
import script from "./RootLayout.vue?vue&type=script&lang=ts&"
export * from "./RootLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports